//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {Add, Edit} from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import MenuIcon from '@mui/icons-material/Menu';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import PowerIcon from '@mui/icons-material/Power';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import {Box, IconButton, Tooltip} from '@mui/material';

type ButtonType = 'delete' | 'modify' | 'delete_strong' | 'jump' | 'add' | 'edit' | 'menu' | 'power_off' | 'power_on' | 'reboot';
//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
export default function SimpleButton(props: {type: ButtonType; onClick: () => void; disabled?: boolean; tooltip?: string}) {
	const {type, onClick, disabled, tooltip} = props;

	const handleClick = (e: React.MouseEvent<HTMLElement>) => {
		e.stopPropagation();
		if (disabled) return;
		onClick();
	};

	const button = (
		<IconButton size="small" onClick={handleClick} disabled={disabled} aria-label={tooltip}>
			{type === 'delete' && <DeleteIcon fontSize="small" />}
			{type === 'modify' && <SettingsIcon fontSize="small" />}
			{type === 'delete_strong' && <DeleteForeverIcon fontSize="small" color="error" />}
			{type === 'jump' && <OpenInNewIcon fontSize="small" />}
			{type === 'add' && <Add fontSize="small" />}
			{type === 'edit' && <Edit fontSize="small" />}
			{type === 'menu' && <MenuIcon fontSize="small" />}
			{type === 'power_off' && <PowerSettingsNewIcon fontSize="small" color={disabled ? 'disabled' : 'error'} />}
			{type === 'power_on' && <PowerIcon fontSize="small" color={disabled ? 'disabled' : 'success'} />}
			{type === 'reboot' && <RestartAltIcon fontSize="small" color={disabled ? 'disabled' : 'warning'} />}
		</IconButton>
	);

	return (
		<Box display="flex" justifyContent="center">
			{tooltip ? (
				<Tooltip title={tooltip} placement="top" arrow>
					<span style={{display: 'inline-flex'}} onClick={e => e.stopPropagation()}>
						{button}
					</span>
				</Tooltip>
			) : (
				button
			)}
		</Box>
	);
}
